/**
 * 檔案用途區塊
 * @module deviceInfo.helper
 * @purpose 解析瀏覽器 userAgent 並回傳系統與瀏覽器的標準列舉值，供前端裝置辨識流程使用。
 * @external https://innotech.atlassian.net/browse/IN-63960
 */
import { UAParser } from 'ua-parser-js';
import { Browser, DevicePlatform } from '@shared/enums/device-platform.enum';

/**
 * 宣告內容用途說明與單號關聯
 * @description 根據 UAParser 回傳的 os.name 對應平台列舉，輸出目前作業系統類型。
 * @purpose 將原始 userAgent 的作業系統資訊轉換為系統內統一的 DevicePlatform 值。
 * @external https://innotech.atlassian.net/browse/IN-63960
 */
export const detectOS = () => {
  const { os } = UAParser(navigator.userAgent);
  if (os.name === 'Windows') {
    return DevicePlatform.Windows;
  }
  if (os.name === 'Android') {
    return DevicePlatform.Android;
  }
  if (os.name === 'macOS') {
    return DevicePlatform.Mac;
  }
  if (os.name === 'iOS') {
    return DevicePlatform.Ios;
  }
  if (os.name === 'Linux') {
    return DevicePlatform.Linux;
  }
  return DevicePlatform.Unknown;
};

/**
 * 宣告內容用途說明與單號關聯
 * @description 根據 UAParser 回傳的 browser.name 對應瀏覽器列舉，輸出主要瀏覽器類型。
 * @purpose 將 userAgent 解析結果標準化為 Browser 列舉，供功能判斷與相容性分流使用。
 * @external https://innotech.atlassian.net/browse/IN-63960
 */
export const detectBrowser = () => {
  const { browser } = UAParser(navigator.userAgent);

  if (browser.name === 'Edge') {
    return Browser.Edge;
  }
  if (browser.name === 'Firefox') {
    return Browser.Firefox;
  }
  if (browser.name === 'Safari') {
    return Browser.Safari;
  }
  if (browser.name === 'Chrome') {
    return Browser.Chrome;
  }
  return Browser.Unknown;
};

/**
 * === llm 分析紀錄區 ===
 * @llm-review-submitted-at 2026-06-14T07:24:02.906Z
 * @llm-review-model gpt-5.3-codex
 * @llm-review-note Added required three-section annotation layout (top/middle/bottom), replaced original comments with structured tags, attached IN-63960 Jira URL to declaration blocks with known origins, and kept runtime code unchanged.
 */
